import FlooringTableHelper from "./flooring-table-helper";
import FlooringsGridHelper from "./flooring-grid-helper";
import FlooringVariationTableHelper from "./flooring-variation-table-helper";

const FlooringHelpers = {
  TableMain: FlooringTableHelper,
  GridMain: FlooringsGridHelper,
  VariationTableMain: FlooringVariationTableHelper,
};

export default FlooringHelpers;
